export enum RailMyBoxRoles {
  ADMIN = 'railmb-cognito-group-admin',
  SUPPORT = 'railmb-cognito-group-support',
  CUSTOMER = 'railmb-cognito-group-customer',
  TYPIST = 'railmb-cognito-group-typist',
  PRICING = 'railmb-cognito-group-pricing',
  ACCOUNTING = 'railmb-cognito-group-accounting',
  OPERATOR = 'railmb-cognito-group-operator',
}
